import { Flex, Skeleton, SkeletonCircle, Spacer, Stack } from "@chakra-ui/react";
import { PageContentHeader, PromptStudioLogo } from "@pufflig/prompt-studio-ui";

export const PromptbookEditorHeaderSkeleton = () => {
  return (
    <PageContentHeader>
      <Flex width="26px" mr="1">
        <PromptStudioLogo />
      </Flex>
      <Skeleton width="24rem" height="1.8rem" />
      <Spacer />
      <Stack gap="spacing-xs" direction="row">
        <SkeletonCircle size="10" />
        <Skeleton width="4rem" height="40px" />
      </Stack>
    </PageContentHeader>
  );
};
